export const Icons = {
  addition: "/assets/images/newIcons/addition.svg",
  clearTextField: "/assets/images/newIcons/clearTextField.svg",
  deleteInTable: "/assets/images/newIcons/deleteInTable.svg",
  editInTable: "/assets/images/newIcons/editInTable.svg",
  micNotInUse: "/assets/images/newIcons/micNotInUse.svg",
  micInUse: "/assets/images/newIcons/micInUse.svg",
  voicePrescriptionIcon: "/assets/images/newIcons/voicePrescriptionIcon.svg",
  patientSummaryIcon: "/assets/images/newIcons/patientSummaryIcon.svg",
  patient360Icon: "/assets/images/newIcons/patient360Icon.svg",
  transcriptionIcon: "/assets/images/newIcons/transcriptionIcon.svg",
  floatingMenuIcon: "/assets/images/newIcons/floatingMenuIcon.svg",
  noRecordsFound: "/assets/images/newIcons/noRecordsFound.svg",
  deletePrescriptionIcon: "/assets/images/newIcons/deletePrescriptionIcon.svg",
  uploadReport: "/assets/images/newIcons/uploadReports.svg",
  careContext: "/assets/images/newIcons/careContext.svg",
  vitals: "/assets/images/newIcons/vitals.svg",
  consentHistory: "/assets/images/newIcons/consentHistory.svg",
  telimedicine: "/assets/images/newIcons/telimedicine.svg",
  handwrittenprescription:
    "/assets/images/newIcons/handwrittenprescription.svg",
  gotodrconsole: "/assets/images/newIcons/gotodrconsole.svg",
  editappointment: "/assets/images/newIcons/editappointment.svg",
  dissabledaddvitals: "/assets/images/newIcons/dissabledaddvitals.svg",
  dissabledcarecontext: "/assets/images/newIcons/dissabledcarecontext.svg",
  dissabledconsent: "/assets/images/newIcons/dissabledconsent.svg",
  dissableduploadReports: "/assets/images/newIcons/dissableduploadReports.svg",
  disabledgotodrconsole: "/assets/images/newIcons/disabledgotodrconsole.svg",
  disabledhandwriten: "/assets/images/newIcons/disabledhandwriten.svg",
  disabledtelimedicine: "/assets/images/newIcons/disabledtelimedicine.svg",
  patienticon: "/assets/images/newIcons/patienticon.svg",
  scanandshareicon: "/assets/images/newIcons/scanandshareicon.svg",

  btotalappointment: "/assets/images/newIcons/btotalappointment.svg",
  btodaysappointment: "/assets/images/newIcons/btodaysappointment.svg",
  bf2fappointmentcalendar:
    "/assets/images/newIcons/bf2fappointmentcalendar.svg",
  bonlineappointmentcalendar:
    "/assets/images/newIcons/bonlineappointmentcalendar.svg",
  bcanceledappointmentcalendar:
    "/assets/images/newIcons/bcanceledappointmentcalendar.svg",
  wappointmentcalendar: "/assets/images/newIcons/wappointmentcalendar.svg",
  totalappointment: "/assets/images/newIcons/totalappointment.svg",
  todaysappointment: "/assets/images/newIcons/todaysappointment.svg",
  f2fappointment: "/assets/images/newIcons/f2fappointment.svg",
  onlineappointment: "/assets/images/newIcons/onlineappointment.svg",
  canceledappointment: "/assets/images/newIcons/canceledappointment.svg",
  pendingappointment: "/assets/images/newIcons/pendingappointment.svg",
  completedappointment: "/assets/images/newIcons/completedappointment.svg",
  appointmentcalendar: "/assets/images/newIcons/appointmentcalender.svg",
  bcompletedappointmentCalendar:
    "/assets/images/newIcons/bcombletedappointmentCalendar.svg",
  bpendinappointment: "/assets/images/newIcons/bpendinappointment.svg",
  bappointmentcalender: "/assets/images/newIcons/bappointmentcalender.svg",

  newappointment: "/assets/images/newIcons/newappointment.svg",
  newdoctor: "/assets/images/newIcons/newdoctor.svg",
  bnewappointment: "/assets/images/newIcons/bnewappointment.svg",
  bnewdoctor: "/assets/images/newIcons/bnewdoctor.svg",
  bdoctorSchedule: "/assets/images/newIcons/bdoctorSchedule.svg",
  modal_blue: "/assets/images/newIcons/modal_blue.svg",

  //Billing Invoicing
  patientDetails: "/assets/images/newIcons/Patient.svg",
  patientDetailsWhite: "/assets/images/newIcons/PatientIconWhite.svg",
  availableServices: "/assets/images/newIcons/AvailableServices.svg",
  availableServicesWhite: "/assets/images/newIcons/AvailableServicesWhite.svg",
  productInventory: "/assets/images/newIcons/ProductInventory.svg",
  productInventoryWhite: "/assets/images/newIcons/ProductInventoryWhite.svg",
  costEstimates: "/assets/images/newIcons/CostEstimates.svg",
  costEstimatesWhite: "/assets/images/newIcons/CostEstimatesWhite.svg",
  billingInvoices: "/assets/images/newIcons/BillingInvoices.svg",
  billingInvoicesWhite: "/assets/images/newIcons/BillingInvoicesWhite.svg",
  paymentDetails: "/assets/images/newIcons/PaymentDetails.svg",
  paymentDetailsWhite: "/assets/images/newIcons/PaymentDetailsWhite.svg",
  reportAnalysis: "/assets/images/newIcons/ReportAnalysis.svg",
  calendar_icon: "/assets/images/newIcons/calendar-sillhouette 2.svg",
  closeIcon: "/assets/images/newIcons/CloseButton.svg",

  manage_roles: "/assets/images/newIcons/Manage_roles.svg",

  appointment_settigs: "/assets/images/newIcons/appointment_settigs.svg",
  settings: "/assets/images/newIcons/settings.png",
  editactive: "/assets/images/newIcons/editactive.svg",
  drconsoledissabled: "/assets/images/newIcons/drconsoledissabled.svg",
  noConsentFound: "/assets/images/newIcons/noConsentFound.svg",
  noappointment: "/assets/images/newIcons/noappointment.svg",
  patientDetailsInSummary:
    "/assets/images/newIcons/patientDetailsInSummary.svg",
  medicalHistoryInSummary:
    "/assets/images/newIcons/medicalHistoryInSummary.svg",

  am: "/assets/images/newIcons/am.svg",
  mm: "/assets/images/newIcons/mm.svg",
  lsm: "/assets/images/newIcons/lsm.svg",
  raa: "/assets/images/newIcons/raa.svg",
  depm: "/assets/images/newIcons/depm.svg",
  bat: "/assets/images/newIcons/bat.svg",
  dm: "/assets/images/newIcons/dm.svg",
  pm: "/assets/images/newIcons/pm.svg",
  fm: "/assets/images/newIcons/fm.svg",
  qr: "/assets/images/newIcons/qr.svg",
  uhr: "/assets/images/newIcons/uhr.svg",
  b: "/assets/images/newIcons/b.svg",
  clvp: "/assets/images/newIcons/clvp.svg",
  RP: "/assets/images/newIcons/rp1.svg",
  ma1: "/assets/images/newIcons/ma1.svg",

  start: "/assets/images/newIcons/start.svg",
  tele: "/assets/images/newIcons/tele.svg",
  quick: "/assets/images/newIcons/quick.svg",
  edit: "/assets/images/newIcons/edit.svg",
  Cancel: "/assets/images/newIcons/Cancel.svg",
  complete: "/assets/images/newIcons/complete.svg",
  slotSettingsInactive: "/assets/images/newIcons/slotSettingsInactive.svg",
  slotSettingsActive: "/assets/images/newIcons/slotSettingsActive.svg",
};
